import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Target } from "lucide-react";
import client from "@/lib/api";
import { EXAMPLE, money, projectProfit, scenarioLabel } from "@/lib/scenarios";

export default function GoalCard() {
  const [data, setData] = useState(null);

  useEffect(() => {
    client.get("/me/goal").then(({ data }) => setData(data)).catch(() => {});
  }, []);

  if (!data?.goal) return null;
  const profit = projectProfit(data.pnl || EXAMPLE, data.goal);

  return (
    <div className="flex flex-col gap-3 rounded-2xl border border-[#E5E2DC] bg-white p-6 sm:flex-row sm:items-center sm:justify-between" data-testid="goal-card">
      <div className="flex items-start gap-4">
        <span className="grid h-10 w-10 shrink-0 place-items-center rounded-xl" style={{ backgroundColor: "var(--tenant-primary-light)" }}><Target size={18} className="tenant-text" /></span>
        <p className="text-neutral-700" data-testid="goal-card-text">
          <span className="font-head font-semibold text-neutral-900">My goal:</span> {scenarioLabel(data.goal)} = <strong className="text-neutral-900">{money(profit)} profit</strong>
        </p>
      </div>
      <Link to="/calculator" data-testid="goal-adjust-link" className="tenant-text shrink-0 text-sm font-medium hover:underline">Adjust in calculator →</Link>
    </div>
  );
}
